export default __webpack_public_path__ + "assets/images/24fcfdd520c838b85118dda95542a52f.png";